<template>
  <div class="cell pa-1 v-card elevation-1" v-ripple v-resize="onResize" :style="'background-color: ' + color" @click="$emit('click')">

    <span class="day-text font-weight-medium" :class="isToday ? 'day-text--today accent--text' : ''">{{ day.getDate() }}</span>

    <transition-group name="avvisi" tag="div">
      <alert-chip v-for="avviso in visibleAvvisi" :key="avviso.id" dense single-line block class="avviso" gradient :color="avviso.colore">
        <b class="mr-1">{{ avviso.ora_avviso }}</b>
        {{ avviso.testo }}
      </alert-chip>
    </transition-group>

    <div v-if="hiddenAvvisiCount > 0" class="more caption font-weight-medium">
      {{ $t('label.altri') }} {{ hiddenAvvisiCount }}
    </div>

  </div>
</template>

<script>
export default {
    name: 'DayCell',
    props: {
        color: String,
        day: Date,
        isToday: Boolean,
        avvisi: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        menu: false,
        height: 0
    }),
    mounted () {
        this.onResize()
    },
    methods: {
        onResize () {
            this.height = this.$el.clientHeight
        }
    },
    computed: {
        visibleAvvisiCount () {
            if (this.avvisi.length <= 0) return 0
            return Math.floor(((this.height - 20) / 24)) - 1
        },
        hiddenAvvisiCount () {
            return this.avvisi.length - this.visibleAvvisiCount
        },
        visibleAvvisi () {
            if (this.avvisi.length > this.visibleAvvisiCount) {
                return this.avvisi.slice(0, this.visibleAvvisiCount)
            } else {
                return this.avvisi
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .cell {
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    cursor: pointer;

    .avviso {
      margin-top: 2px;
    }

    .avvisi {
      $duration: .4s;

      &-enter-active, &-leave-active, &-move {
        will-change: transform, opacity;
        transition: transform $duration, opacity $duration;
      }

      &-enter {
        opacity: 0;
        transform: translateY(10px);
      }

      &-leave-to {
        opacity: 0;
        transform: translateX(-5px);
      }
    }

    .day-text {
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 20px !important;
      text-align: center;

      &--today {
        border: solid 1.2px #00838f;
      }

    }

    .more {
      margin-top: 4px;
      margin-left: 8px;
    }
  }
</style>
